import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=22d17092&scoped=true&"
import script from "./Thumbnail.vue?vue&type=script&lang=ts&"
export * from "./Thumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./Thumbnail.vue?vue&type=style&index=0&id=22d17092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d17092",
  null
  
)

export default component.exports